module.exports = __webpack_public_path__ + "static/media/times-new-roman.895958fa.ttf";